import React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

import HomePageContent from './HomePageContent';
import PageNavigationTabs from './PageNavigationTabs';
import useSmUp from './../hooks/useSmUp';
import { useEffect } from 'react';

const HomePageMainSearchStyled = styled('div')(({ theme }) => ({
    position: 'relative',
    overflow: 'hidden',
    backgroundColor: '#fafafa',
    [`${theme.breakpoints.up('sm')}`]: {
        maxWidth: '100%',
        margin: 'auto'
    }
}));

const BackgroundShape = styled('div')(({ theme }) => ({
    position: 'absolute',
    top: '-50%',
    right: '-20%',
    width: '100%',
    height: '200%',
    background: theme.palette.primary.main,
    opacity: 0.03,
    borderRadius: '50%',
    transform: 'rotate(-20deg)',
    zIndex: 0,
}));

const ContentWrapper = styled(Box)(({ theme }) => ({
    maxWidth: '1400px',
    margin: '0 auto',
    padding: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
        padding: theme.spacing(8),
    },
}));

const HomePageMainSearch = props => {
    const matches = useSmUp();

    useEffect(() => {
                window.scrollTo(0, 0);
            }, []);

    return (
        <HomePageMainSearchStyled>
            <BackgroundShape />
            <ContentWrapper>
                <HomePageContent />
                {matches && <PageNavigationTabs/>}
                {!matches && 
                    <Grid item xs={12} sx={(theme) => ({
                        [`${theme.breakpoints.only('xs')}`]: {
                            order: 3
                        }
                    })}>
                        <PageNavigationTabs/>
                    </Grid>
                }
            </ContentWrapper>
        </HomePageMainSearchStyled>
    );
};

export default HomePageMainSearch;